document.addEventListener('DOMContentLoaded', () => {
 const root = document.querySelector('[data-optical-product]');
 if (!root) return;
 const modeOptions = [...root.querySelectorAll('input[name="purchase_mode"]')];
 const panel = root.querySelector('[data-lens-panel]');
 const rxFields = [...root.querySelectorAll('[data-lens-purpose], [data-lens-finish], [data-lens-index], [data-rx-status]')];
 const rxSummary = root.querySelector('[data-rx-summary]');
 const total = root.querySelector('[data-pdp-total]');
 const price = root.querySelector('[data-frame-price]');
 const label = root.querySelector('[data-total-label]');
 const buy = root.querySelector('[data-pdp-buy]');
 const enquiry = root.querySelector('[data-pdp-enquiry]');
 const frameAvailability = root.querySelector('[data-pdp-frame-availability]');
 const variant = root.querySelector('[data-frame-variant]');
 const feedback = root.querySelector('[data-pdp-feedback]');
 const save = root.querySelector('[data-save-frame]');
 const saveText = root.querySelector('[data-save-text]');
 const money = cents => new Intl.NumberFormat(root.dataset.locale || 'en-GB', {style:'currency',currency:root.dataset.currency || 'GBP'}).format(cents / 100);
 const getPrice = () => variant ? Number(variant.selectedOptions[0].dataset.price || 0) : Number(root.querySelector('[data-frame-price]').getAttribute('data-cents') || 0);
 const initialPrice = Number(root.querySelector('[data-frame-price]').dataset.cents || 0);
 const actualPrice = () => variant ? getPrice() : initialPrice;
 function refresh() {
  if (rxSummary) rxSummary.textContent = rxFields.map(field => field.value).join(' · ');
  const rx = modeOptions.find(input => input.checked)?.value === 'prescription';
  if (panel) panel.hidden = !rx; if (buy) buy.hidden = rx; if (frameAvailability) frameAvailability.hidden = rx; if (enquiry) enquiry.hidden = !rx;
  const display = money(actualPrice()); price.textContent = display; if (total) total.textContent = display;
  if (label) label.textContent = rx ? 'Frame price (lenses quoted separately)' : 'Frame total';
 }
 modeOptions.forEach(input => input.addEventListener('change', refresh));
 rxFields.forEach(field => field.addEventListener('change', refresh));
 if (variant) variant.addEventListener('change', refresh);
 if (buy) buy.addEventListener('click', async () => {
   buy.disabled = true; feedback.textContent = 'Adding your frame to the bag…';
   const id = Number(variant ? variant.value : root.querySelector('[data-default-variant]').value);
   try {
     const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
     if (!response.ok) throw new Error('cart');
     document.dispatchEvent(new CustomEvent('vueraith:cart-added')); buy.disabled=false;feedback.textContent='Added to your bag.';
   } catch (_) { feedback.textContent = 'Could not add this frame. Please try again.'; buy.disabled = false; }
 });
 if (save) {
   const key = 'vueraith:saved-frames';
   const url = root.dataset.productUrl;
   function read() { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (_) { return []; } }
   function show() { const saved = read().some(item => item.url === url); save.setAttribute('aria-pressed',String(saved)); saveText.textContent = saved ? 'Saved' : 'Save'; save.setAttribute('aria-label',saved?'Remove frame from saved items':'Save frame for later'); }
   save.addEventListener('click',()=>{try{ const list=read();const updated=list.some(item=>item.url===url)?list.filter(item=>item.url!==url):[...list,{url,title:root.dataset.productTitle}].slice(-24);localStorage.setItem(key,JSON.stringify(updated));show();document.dispatchEvent(new Event('vueraith:saved-updated'));feedback.textContent='Your shortlist has been updated on this device.';}catch(_){feedback.textContent='Saving is not available in this browser.'}});
   show();
 }
 refresh();
});